<template>
    <div class="paracontents">
        <div class="phonenew">
            <div class="new">
                <div class="title">经典版维码器</div>
                <div class="write">| 让 | 您 | 再 | 无 | 离 | 线 | 之 | 忧 |</div>
                <div class="write1">多种支付方式 / 性价比高 / 兼容性强</div>
                <div class="weimaqi">
                    <img src="./images/phone/product.png" alt="维码器">
                </div>
            </div>
        </div>
        <div class="para">
            <div class="title">经典版维码器硬件参数</div>
            <div class="write">全新的联网方式，让您再无离线之忧</div>
            <div class="port">
                <div class="left">
                    <div class="left-num">
                        <div class="line one"></div>
                        <p>8cm</p>
                        <div class="line two"></div>
                    </div>
                    <div class="left-numtwo">
                        <div class="line one"></div>
                        <p>1.6cm</p>
                        <div class="line two"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="nums">
                        <div class="line one"></div>
                        <p>8cm</p>
                        <div class="line two"></div>
                    </div>
                    <div class="size"><img src="./images/phone/Product_size.png" alt="维码器尺寸"></div>
                </div>
            </div>
            <div class="tables">
                    <table class="table one">
                            <caption>基本参数</caption>
                        <tbody>
                            <tr>
                                <td>供电电压</td>
                                <td>12V</td>
                            </tr>
                            <tr>
                                <td>供电电流</td>
                                <td>>1A</td>
                            </tr>
                            <tr>
                                <td>功　　率</td>
                                <td>GPRS--12w;WIFI--6W</td>
                            </tr>
                            <tr>
                                <td>支付方式</td>
                                <td>微信、支付宝、QQ钱包</td>
                            </tr>
                            <tr>
                                <td>外观尺寸</td>
                                <td>8cm × 8cm × 1.6cm</td>
                            </tr>
                            <tr>
                                <td>联网方式</td>
                                <td>2G/4G（移动/联通） / WIFI / 蓝牙</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table two">
                        <caption>版本说明</caption>
                        <tbody>
                            <tr>
                                <td>脉冲通用版</td>
                                <td>适用于市场上所有脉冲通用型设备</td>
                            </tr>
                            <tr>
                                <td>ICT纸钞机专用版</td>
                                <td>适用于台湾ICT纸钞机的自助设备</td>
                            </tr>
                            <tr>
                                <td>英国纸钞机专用版</td>
                                <td>适用于英国纸钞机的自助设备</td>
                            </tr>
                            <tr>
                                <td>MDB协议专用版</td>
                                <td>售货机MDB协议专用</td>
                            </tr>
                            <tr>
                                <td>串口协议对接专用版</td>
                                <td>用于实现与设备的串口通讯</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
    </div>
 </div>
</template>
<script>
export default {
  name:'parameter',
}
</script>

<style scoped>
.paracontents{
    width:100%;
    height: 100%;
    /* height: 100vh; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.paracontents .para{
    width: 100%;
    /* height: 100%; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.phonenew{
    width: 100%;
    /* height: 100%; */
    background-color: #fafafa;
}
.phonenew .new{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.phonenew .title{
    font-size: 22px;
    line-height: 22px;
    letter-spacing: 2px;
    color: #333;
    margin-top: 69px;
}
.phonenew .write{
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 1px;
    color: #666;
    margin-top: 19px;
}
.write1{
    font-size: 11px;
    line-height: 11px;
    letter-spacing: 1px;
    color: #666;
    margin-top: 19px;
}
.phonenew .weimaqi{
    width: 80%;
     margin-top: 70px;
}
.phonenew .weimaqi img{
    width: 100%;
}
.para .title{
    font-size: 22px;
    line-height: 22px;
    letter-spacing: 0.5px;
    color: #000;
        margin-top: 50px;
}
.para .write{
font-size: 11px;
line-height: 11px;
color: #000;
margin-top: 13px;
}
.para .port{
    width: 100%;
    height: 60vh;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    margin-top:45px;
}
.port .nums{
    /* width: 80%; */
    width: 63vw;
        display: flex;
    justify-content: space-between;
    align-items: center;
}
.nums .line{
    width: 30%;
    height: 1px;
    background: #eaeaea;
    position: relative;
}

.nums .line.one::after{
    content: '';
    position: absolute;
    height: 14px;
    width: 1px;
    background: #eaeaea;
    top: -6px;
    left: 0;
}
.nums .line.two::after{
    content: '';
    position: absolute;
    height: 14px;
    width: 1px;
    background: #eaeaea;
    top: -6px;
    right: 0;
}
.nums p,.left-numtwo p,.left-num p{
    font-size: 11px;
	letter-spacing: 0.5px;
	color: #333333;
}
.left{
    /* height: 340px; */
    height: 90vw;
    width: 21vw;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}
.left-numtwo p,.left-num p{
    transform: rotate(90deg);
}
    
.left-num{
    /* height: 190px; */
    height: 63vw;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
     position: relative;
    top: 7vw;
}
.left-num .line{
        width: 1px;
    height: 18vw;
    background: #eaeaea;
    position: relative;
}
.left-num .line.one::after,.left-numtwo .line.one::after{
    content: '';
    position: absolute;
    height: 1px;
    width: 14px;
    background: #eaeaea;
    top: 0px;
    left: -6px;
}
.left-num .line.two::after,.left-numtwo .line.two::after{
    content: '';
    position: absolute;
    height: 1px;
    width: 14px;
    background: #eaeaea;
    bottom: 0px;
    right: -6px;
}
.left-numtwo{
    /* height: 70px; */
    height: 13vw;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}
.left-numtwo .line{
        width: 1px;
    height: 2vw;
    background: #eaeaea;
    position: relative;
}
.para .size{
    /* width: 80%; */
    width: 63vw;
    margin-top: 15px;
}
.para .size img{
    width: 100%;
}
.para .tables{
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 50px 15px 0px;
    box-sizing: border-box;
}
.para table{
border-collapse:collapse;
width: 100%;
}
.para table caption{
    width: 100%;
	height: 44px;
    line-height: 44px;
	background-color: #eaeaea;
    font-size: 12px;
	letter-spacing: 1px;
	color: #333333;
   border-bottom: 1px solid #eaeaea;
   border-top: 1px solid #eaeaea;
}
.para table tbody tr{
    width: 100%;
    height: 44px;
}
.para table tbody tr td{
    font-size: 11px;
    letter-spacing: 1px;
    color: #333333;
    height: 44px;
}
.para .table.one tbody tr td,.table.two tbody tr td{
    border-bottom: 1px solid #eaeaea;
}
.para .table.one tbody tr td:nth-child(1){
    width: 25%;
    height: 44px;
    text-align: center;
    border-right: 1px solid #eaeaea;
}
.para .table.one tbody tr td:nth-child(2){
    width: 75%;
}
.para .table.two{
    margin-top: -2px;
    margin-bottom: 50px;
}
.para .table.two tbody tr td:nth-child(1){
    width: 37%;
    height: 44px;
    border-right: 1px solid #eaeaea;
    box-sizing: border-box;
    padding-left: 1%;
}
.para .table.two tbody tr td:nth-child(2){
    width: 63%;
}
.para .table tbody tr td:nth-child(2){
    padding-left: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/hardProduct/parameter.vue